'use client';

import {getEnv} from 'environment/public.environment';
import RettsstiftelsePanel, {rettsstiftelsesSort} from 'features/rettsstiftelse/components/losore/rettsstiftelse-panel';
import {VirksomhetRettsstiftelserWrapper} from 'features/rettsstiftelse/model/losore/rettsstiftelse';
import {DescribedText} from 'features/terms/components/described-text';
import {ConceptID} from 'features/terms/felles-datakatalog/concept-ids';
import {FdkText} from 'features/terms/components/fdk-text';
import {Trans, useTranslation} from 'react-i18next';
import {createUseStyles} from 'react-jss';

const useStyles = createUseStyles(
  {
    results: {
      marginBottom: '3rem',
    },
    rettsstiftelseCount: {
      fontWeight: '600',
      fontSize: '1rem',
    },
  },
  {name: 'VirksomhetResultSection'}
);

export const VirksomhetResultSection = ({data, orgnr}: {data?: VirksomhetRettsstiftelserWrapper; orgnr: string}) => {
  const styles = useStyles();
  const {t, i18n} = useTranslation(['common', 'virksomhet']);

  return (
    <section id='results' className={styles.results}>
      <p className={styles.rettsstiftelseCount}>
        {t('virksomhet:number-of-liens', {
          count: data?.rettsstiftelser?.length ?? 0,
          virksomhet: data?.virksomhet?.navn ?? orgnr,
        })}
      </p>
      <div>
        <Trans i18n={i18n} i18nKey='virksomhet:utlegg-notice'>
          PRE
          {getEnv().features.fellesDatakatalog ? (
            <DescribedText
              description={
                <p>
                  <b>{t('common:itu')}</b>
                  <FdkText conceptId={ConceptID.ITU} />
                </p>
              }
            >
              TERM
            </DescribedText>
          ) : (
            <>TERM</>
          )}
          POST
        </Trans>
      </div>
      {!!data?.rettsstiftelser?.length &&
        data.rettsstiftelser
          .sort(rettsstiftelsesSort)
          .map((r, i) => <RettsstiftelsePanel key={`${i}-${r.dokumentnummer}`} index={i} rettsstiftelse={r} />)}
    </section>
  );
};
